<div [class.joyride-arrow__top]="position == 'top'"
     [class.joyride-arrow__bottom]="position == 'bottom'"
     [class.joyride-arrow__left]="position == 'left'"
     [class.joyride-arrow__right]="position == 'right'">
</div>